export default {
    DEFAULT: 'default',
    APPROVAL_LIKELIHOOD: 'approval-likelihood',
};
